export default __webpack_public_path__ + "static/img43v-2581a28e03997aa5a887b046827a1c52.jpg";